import React from 'react';
// Faz C (2026-09-03): Basim.js'ten satır aralığıyla BİREBİR taşındı — davranış değişmedi.

function SoruListesi({ sorular, onSil, onTasi, dragHandlers }) {
  return (
    <div className="space-y-1 max-h-[420px] overflow-y-auto pr-1">
      {sorular.map((s, i) => (
        <div key={s.id} {...dragHandlers(i)}
          className="basim-soru-blogu group flex items-center gap-2 p-2 rounded-lg border border-gray-100 bg-gray-50 hover:bg-white hover:border-blue-200 transition-colors">
          <span className="text-gray-400 cursor-grab opacity-50 group-hover:opacity-100" title="Sürükle">⋮⋮</span>
          <span className="text-[11px] font-bold text-gray-400 w-6 text-center">{i + 1}</span>
          {s.public_no != null && <span className="text-[10px] bg-gray-800 text-white px-1.5 py-0.5 rounded font-mono">#{s.public_no}</span>}
          <div className="flex-1 min-w-0">
            <div className="text-xs font-semibold text-gray-700 truncate">{s.konu || '—'}</div>
            <div className="text-[10px] text-gray-400 truncate">{(s.soru_metni_latex || '').slice(0, 70).replace(/\$/g, '').replace(/\\\w+/g, ' ').trim()}</div>
          </div>
          <span className="text-[10px] text-gray-500 px-1.5 hidden md:inline">{s.zorluk || '—'}</span>
          <div className="flex flex-col gap-0.5 opacity-50 group-hover:opacity-100">
            <button onClick={() => onTasi(i, -1)} disabled={i === 0} className="text-[10px] px-1.5 leading-none disabled:opacity-30 hover:bg-gray-200 rounded">▲</button>
            <button onClick={() => onTasi(i, +1)} disabled={i === sorular.length - 1} className="text-[10px] px-1.5 leading-none disabled:opacity-30 hover:bg-gray-200 rounded">▼</button>
          </div>
          <button onClick={() => onSil(s.id)} className="text-red-500 text-xs hover:bg-red-50 rounded px-1.5 py-1 opacity-50 group-hover:opacity-100">✕</button>
        </div>
      ))}
    </div>
  );
}

export default SoruListesi;
